module.exports = __webpack_public_path__ + "assets/twitter-icon-32.png?7682ef09c0be8f595fad801d38b66c85";